import { useSyncExternalStore } from 'react';
import { local } from './storage';
export type Appearance = { sidebar: 'theme' | 'light' | 'dark'; theme: 'system' | 'light' | 'dark'; accent: 'navy' | 'blue' | 'green' | 'violet'; density: 'comfortable' | 'compact'; text: 'standard' | 'large' };
export const DEFAULT_APPEARANCE: Appearance = { sidebar: 'theme', theme: 'system', accent: 'navy', density: 'comfortable', text: 'standard' };
export function normalizeAppearance(value: unknown): Appearance {
  const input = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  return {sidebar: input.sidebar === 'dark' || input.sidebar === 'light' ? input.sidebar : 'theme',theme: ['system','light','dark'].includes(String(input.theme)) ? input.theme as Appearance['theme'] : 'system',accent:['navy','blue','green','violet'].includes(String(input.accent)) ? input.accent as Appearance['accent'] : 'navy',density:input.density === 'compact' ? 'compact' : 'comfortable',text:input.text === 'large' ? 'large' : 'standard'};
}
const KEY = 'nl-aos-appearance';
function read(): Appearance {
  try { const stored=local.get(KEY); return stored ? normalizeAppearance(JSON.parse(stored)) : normalizeAppearance({theme:local.get('nl-aos-theme')}); }
  catch { return {...DEFAULT_APPEARANCE}; }
}
let current = read();
const listeners = new Set<()=>void>();
let media: MediaQueryList | undefined;
let started = false;
function apply() {
  const root=document.documentElement;
  root.dataset.theme=current.theme === 'system' ? media?.matches ? 'dark' : 'light' : current.theme;
  root.dataset.sidebar=current.sidebar;root.dataset.accent=current.accent;root.dataset.density=current.density;root.dataset.textSize=current.text;
}
export function initializeAppearance() {
  if(started)return;started=true;
  media=matchMedia('(prefers-color-scheme: dark)');
  media.addEventListener('change',apply);
  window.addEventListener('storage',event=>{if(event.key===KEY || event.key===null){current=read();apply();listeners.forEach(fn=>fn());}});
  apply();
}
export function saveAppearance(update: Partial<Appearance>) {
  current=normalizeAppearance({...current,...update});
  local.set(KEY,JSON.stringify(current));
  local.remove('nl-aos-theme');
  apply();listeners.forEach(fn=>fn());
}
export function useAppearance() {
  const value=useSyncExternalStore(listener=>{listeners.add(listener);return()=>{listeners.delete(listener);};},()=>current);
  return {appearance:value,update:saveAppearance,reset:()=>saveAppearance(DEFAULT_APPEARANCE)};
}
